module.exports = __webpack_public_path__ + "img/tjrw.59080d94.svg";